module.exports = __webpack_public_path__ + "static/media/bg-transparent.1db521d9.png";